import React, { ReactElement } from 'react';
import { Divider } from 'antd';
import KakaoLogin from '@views/main/KakaoLogin';
import GoogleLogin from '@views/main/GoogleLogin';

interface LoginFormProps {
  showLoading?: boolean;
  extra?: string | ReactElement;
  loading?: boolean;
  showMessage?: string;
  message?: string;
}

const LoginProviderSelection = (props: LoginFormProps) => {
  return (
    <div>
      <KakaoLogin {...props} />
      <GoogleLogin {...props} />
    </div>
  );
};

export default LoginProviderSelection;
